var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import { FaDownload, FaTrashAlt } from 'react-icons/fa';
import { useDownloadAttachment } from 'utils';
import { useSearchParams } from 'react-router-dom';
export const FileInput = forwardRef((_a, ref) => {
    var { type, isInvalid, label, setValue, value = [] } = _a, rest = __rest(_a, ["type", "isInvalid", "label", "setValue", "value"]);
    const [searchParams] = useSearchParams();
    const { execute: download } = useDownloadAttachment(Number(searchParams.get('offerId') || 0));
    const handleFileChange = (e) => {
        if (e.target.files) {
            const fileArray = Array.from(e.target.files).map((file, index) => ({
                id: index,
                file: file,
                fileType: file.type,
                fileSize: file.size,
                fileName: file.name
            }));
            setValue(rest.name, [...value, ...fileArray], { shouldDirty: true, shouldTouch: true });
        }
    };
    const handleDeleteFile = (index) => {
        const updatedFiles = value === null || value === void 0 ? void 0 : value.filter((_, i) => i !== index);
        setValue(rest.name, updatedFiles, { shouldDirty: true, shouldTouch: true });
    };
    return (_jsxs(_Fragment, { children: [_jsx(Row, { children: _jsxs(Col, Object.assign({ md: 12 }, { children: [_jsx(Form.Label, Object.assign({ className: 'file-upload', htmlFor: rest.name }, { children: label })), _jsx(Form.Control, Object.assign({}, rest, { ref: ref, id: rest.name, as: 'input', disabled: rest.disabled, isInvalid: isInvalid, type: 'file', multiple: true, accept: '.pdf, .msg, .eml, .xlsx, .txt, .jpg, .jpeg, .png, .ppt, .pptx, .doc, .docx', onChange: handleFileChange, value: '', hidden: true }))] })) }), _jsx(Col, { children: value &&
                    value.length > 0 &&
                    value.map((file, index) => (_jsxs(Row, Object.assign({ className: 'align-items-center mt-1' }, { children: [_jsx(Col, Object.assign({ md: 10 }, { children: file.fileName })), _jsx(Col, Object.assign({ md: 1 }, { children: _jsx("a", Object.assign({ className: '', title: 'Download file', onClick: () => download(file.id, String(file.fileName || `attachment-${index}`)) }, { children: _jsx(FaDownload, {}) })) })), !rest.disabled ? (_jsx(Col, Object.assign({ md: 1 }, { children: _jsx(FaTrashAlt, { className: 'icon-delete-attachment', title: 'Delete file', onClick: () => handleDeleteFile(index) }) }))) : null] }), index))) })] }));
});
FileInput.displayName = 'FileInput';
